import { getToken, setToken, removeToken } from '@/utils/auth'
import { login, wxLogin, getUserInfo } from '@/api/account'

export default {
  state: {
    token: getToken(),
    profile: '',
    name: '',
    avatar: '',
    is_leader: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PROFILE: (state, profile) => {
      state.profile = profile
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_IS_LEADER: (state, isLeader) => {
      state.is_leader = isLeader
    }
  },

  actions: {
    async LoginByMobile ({ commit }, userInfo) {
      let mobile = userInfo.mobile.trim()
      let response = await login({
        mobile: mobile,
        password: '123456'
      })

      let token = response.data.token
      commit('SET_TOKEN', token)
      setToken(token)
      return token
    },
    async LoginByWx ({ commit }, data) {
      let response = await wxLogin(data)

      let token = response.data.token
      commit('SET_TOKEN', token)
      setToken(token)
      return token
    },
    async GetUserInfo ({ commit, state }) {
      let response = await getUserInfo()
      let info = response.data

      commit('SET_NAME', info.nickname)
      commit('SET_AVATAR', info.avatar_url)
      commit('SET_IS_LEADER', info.is_leader)
      commit('SET_PROFILE', info)
      return true
    },
    setUserProfile ({ commit }, info) {
      commit('SET_PROFILE', info)
    },
    Logout ({ commit }) {
      commit('SET_NAME', '')
      commit('SET_TOKEN', '')
      removeToken()
      return ''
    }
  }
}
